import { globalSale } from './catalog.js'

export function peptideDetailPath(id) {
  return `/peptides/${id}`
}

export function resolveVariants(product) {
  if (product.variants?.length) return product.variants
  return [
    {
      id: 'default',
      label: 'Standard',
      concentration: product.concentration ?? '',
      price: product.price ?? 0,
      compareAtPrice: product.compareAtPrice,
    },
  ]
}

export function getDefaultVariant(product) {
  const list = resolveVariants(product)
  const id = product.defaultVariantId
  if (id) return list.find((v) => v.id === id) ?? list[0]
  return list[0]
}

// Live inventory (admin's per-variant quick status selector) always wins over
// the static stock value stored on the product's own variant record — that
// field is only ever set once, from the "Initial Stock Status" dropdown in
// the product editor, and never updated again after that.
export function getVariantStock(product, variant, inventory) {
  const liveKey = product?.id && variant?.id ? `${product.id}__${variant.id}` : null
  const live = liveKey ? inventory?.[liveKey]?.stock : null
  return live ?? variant?.stock ?? product.merchandise?.stock ?? 'in_stock'
}

export function isVariantAddToCartDisabled(product, variant, inventory) {
  const s = getVariantStock(product, variant, inventory)
  return s === 'out_of_stock' || s === 'coming_soon'
}

export function isSaleActive(_product) {
  return Boolean(globalSale?.active)
}

export function saleBadgeLabel(product) {
  if (!isSaleActive(product)) return null
  return globalSale.label?.trim() || 'Sale'
}

export function showCompareAtPrice(product, variant) {
  return isSaleActive(product) && variant.compareAtPrice != null && variant.compareAtPrice > variant.price
}

export function stockAlertLabel(product, variant, inventory) {
  const s = getVariantStock(product, variant, inventory)
  if (s === 'out_of_stock') return 'Out of stock'
  if (s === 'coming_soon') return 'Coming soon'
  if (s === 'low_stock') return 'Low stock'
  return null
}

export function formatPriceRange(product) {
  const list = resolveVariants(product)
  const prices = list.map((v) => v.price)
  const min = Math.min(...prices)
  const max = Math.max(...prices)
  if (list.length > 1 && min !== max) return { prefix: 'From ', value: min }
  return { prefix: '', value: min }
}

export const lowStockBadgeStyle = {
  color: '#e8c4c0',
  border: '1px solid rgba(200, 120, 120, 0.55)',
  background: 'rgba(44, 24, 26, 0.55)',
  fontWeight: 700,
  fontSize: '13px',
  letterSpacing: '0.05em',
}

export const comingSoonBadgeStyle = {
  color: '#e8dcc8',
  border: '1px solid rgba(200, 160, 100, 0.5)',
  background: 'rgba(48, 38, 24, 0.55)',
  fontWeight: 700,
  fontSize: '13px',
  letterSpacing: '0.05em',
}
